import type { Cell } from '../components/MapComponent';

/**
 * Check whether a bubble overlay can be placed on a map cell.
 *
 * @param cell Cell to inspect.
 * @returns Whether the cell supports a bubble overlay.
 */
export function canSpawnBubbleOnCell(cell?: Cell): boolean {
  // Bubbles must target an enabled map cell.
  if (!cell?.enabled) return false;

  // Bubbles cannot replace an existing overlay.
  if (cell.overlay) return false;

  // Empty cells can receive bubbles.
  const base = cell.base?.entity.c.block;
  if (!base) return true;

  // Flower Fidget intentionally cannot receive bubbles.
  if (base.blockId === 'flowerFidget') return false;

  // Bubble overlays only support blocks occupying a single cell.
  return base.width <= 1 && base.height <= 1;
}
